export default __webpack_public_path__ + "static/media/gallery_11.ac865d64.jpg";